import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import logo from '../../images/inflo_logo.png';
import MobileFooter from '../widgets/MobileFooter';

interface RegisterLayoutProps {
  title: string;
  children: React.ReactNode;
}

const RegisterLayout: React.FC<RegisterLayoutProps> = ({ title, children }) => {
  return (
    <>
      <Helmet>
        <style>{'body { background-color: white!important; }'}</style>
      </Helmet>
      <div className="paddingBlockInflo login-inflo-page">
        <Row
          className="show-grid"
          style={{ marginRight: '0', marginLeft: '0' }}
        >
          <Col xs={5} className="loginInfloForm">
            <div className="logoInflo">
              <div style={{ float: 'left', marginRight: '45px' }}>
                <img src={logo} alt="logo" />
              </div>
              <div>{title}</div>
            </div>
            {children}
            <MobileFooter />
          </Col>
        </Row>
      </div>
    </>
  );
};

export default RegisterLayout;
